import React from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import SyncActivity from '@/components/shared/SyncActivity';
import useAssignmentSyncState from './useAssignmentSyncState';

// AIDEV-NOTE: The same raw request/response log support opens from the teacher's Assignments and Grades
// pages, routed so a link lands on it. ?student_id narrows it to one student's grade sync attempts —
// never ?student, which StudentSigninStrategy reads as a sign-in hash on dev and demo (500s on load).
const SyncLog = () => {
  const navigate = useNavigate();
  const { id = '' } = useParams();
  const [params] = useSearchParams();
  const { data } = useAssignmentSyncState(id);
  const studentId = Number(params.get('student_id')) || undefined;
  const student = data?.students.find(row => row.student_id === studentId);

  return (
    <SyncActivity
      isOpen
      assignmentId={Number(id)}
      gradeSyncOnly={studentId != null}
      studentId={studentId}
      studentLabel={student?.student_name}
      onClose={() => navigate('..')}
    />
  );
};

export default SyncLog;
